import {TimelineEventProducer} from './TimelineEventProducer'

export interface TimelineEventData<E> {
  // UNIQUE ID FOR THE EVENT
  _id: string
  // EVENT DATE CREATED
  date: number
  // REACT COMPONENT WHICH WILL BE RENDERED IN TIMELINE - IT WILL RECEIVE producer PROPS
  // eslint-disable-next-line @typescript-eslint/ban-types
  element: Function
  // PROPS FOR THE element
  props: E
  // ELEMENT ALIGNMENT IN PARENT VIEW
  alignment: 'flex-start' | 'center' | 'flex-end'
  // USER AVATAR URL
  avatar?: string
  // CONTEXT PRODUCER
  producer: TimelineEventProducer
  // Will not wrap the event in default timeline wrapper - see TimelineEvent.tsx implementation
  detached?: boolean
  // ADAPTER ID THAT EVENT IS GENERATED FROM
  adapterId: string
}

export type TimelineAdapterId = string

export abstract class TimelineAdapter<Event> {
  static id: TimelineAdapterId
  abstract producer: TimelineEventProducer

  abstract load(): Promise<TimelineEventData<Event>[]>

  public abstract complete(): void
}
